var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 24.4863H17.657",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1143 13.3432C22.1143 11.7671 21.4882 10.2555 20.3737 9.14101C19.2592 8.02652 17.7476 7.40039 16.1714 7.40039C14.5953 7.40039 13.0837 8.02652 11.9692 9.14101C10.8547 10.2555 10.2286 11.7671 10.2286 13.3432V18.5432C10.2286 19.1343 9.99377 19.7012 9.57584 20.1191C9.15791 20.5371 8.59105 20.7718 8 20.7718H24.3429C23.7518 20.7718 23.1849 20.5371 22.767 20.1191C22.349 19.7012 22.1143 19.1343 22.1143 18.5432V13.3432Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8,
    height: 20.8,
    fill: "white",
    transform: "translate(4.80005 4.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/Bell_Icon.09436852dc3bd9a1c8e149ae5a8baf9a.svg";
export { ForwardRef as ReactComponent };